import {
    ASSIGNMENTS__REQUESTED__SUCCEEDED,
    ASSIGNMENT__COPY__REQUESTED__SUCCEEDED,
    ASSIGNMENTS__COPY__REQUESTED__SUCCEEDED,
    ASSIGNMENT__CREATE__REQUESTED__SUCCEEDED,
    ASSIGNMENT__UPDATE__REQUESTED__SUCCEEDED,
    ASSIGNMENT__DELETE__REQUESTED__SUCCEEDED,
} from '../constants/actionTypes';
import _ from 'lodash';

const INITIAL_STATE = {},
    id = iteratee => {
        return iteratee.id;
    }
;

export default function assignments(state = INITIAL_STATE, action) {
    switch (action.type) {

        case ASSIGNMENTS__REQUESTED__SUCCEEDED: {
            const { assignments } = action.payload;

            return _.mapKeys(assignments.entities, id);
        }

        case ASSIGNMENT__DELETE__REQUESTED__SUCCEEDED: {
            const { assignmentId } = action.payload;

            return _.mapKeys(
                _.filter(
                    state,
                    assignment => {
                        return assignmentId !== assignment.id;
                    }
                ),
                id
            );
        }

        case ASSIGNMENT__CREATE__REQUESTED__SUCCEEDED: {
           const { assignment } = action.payload;

           return {
               ...state,
               ..._.mapKeys({ assignment }, id),
           };
        }

        case ASSIGNMENT__COPY__REQUESTED__SUCCEEDED: {
            const { assignment } = action.payload;

            return {
                ...state,
                ..._.mapKeys({ assignment }, id),
            };
        }

        case ASSIGNMENTS__COPY__REQUESTED__SUCCEEDED: {
            const { assignments } = action.payload;

            return {
                ...state,
                ..._.mapKeys(assignments.entities, id),
            };
        }

         case ASSIGNMENT__UPDATE__REQUESTED__SUCCEEDED: {
             const { assignment } = action.payload;

             return {
                 ...state,
                 ..._.mapKeys({ assignment }, id),
             };
        }


        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/assignmentsReducer.js
 **/